<template>
  <div class="table-pagination">
    <div class="pagination-info" v-if="hasInfo">共 {{ total }} 项数据</div>
    <div class="pagination-controls">
      <v-select v-if="hasSizes" v-model="pageSize" :disabled="disabled" :items="pageSizeItems" variant="outlined" density="compact" hide-details
        @update:model-value="handleSizeChange" rounded="pill" :color="$attrs.color" />
      <v-pagination v-model="modelValue" :length="length" v-bind="$attrs" :total-visible="5" rounded="pill" size="small"
        @update:model-value="onChange" :disabled="disabled" />
      <div class="jump-to-page" v-if="hasJump">
        <span>跳至</span>
        <v-text-field :disabled="length === 1 || disabled" v-model.number="jumpPage" type="number" variant="outlined" density="compact" class="jump-input"
          hide-details @keyup.enter="handleJumpToPage" @blur="handleJumpToPage" rounded="pill" :color="$attrs.color" />
        <span>/{{ length }} 页</span>
      </div>
    </div>
  </div>
</template>
<script setup>
import { computed, ref } from 'vue'

/** 当前页码 */
const modelValue = defineModel('modelValue', {
  type: Number,
  default: 1
})

/** 每页条数 */
const pageSize = defineModel('pageSize', {
  type: Number,
  default: 10
})

const props = defineProps({
  /** 总数 */
  total: {
    type: Number,
    default: 0
  },
  /** 是否禁用分页组件 */
  disabled: {
    type: Boolean,
    default: false
  },
  /** 是否显示跳转页码输入框 */
  hasJump: {
    type: Boolean,
    default: false
  },
  /** 是否显示每页条数选择框 */
  hasSizes: {
    type: Boolean,
    default: false
  },
  /** 是否显示总数信息 */
  hasInfo: {
    type: Boolean,
    default: true
  }
})

const jumpPage = ref(1)

// 跳转到指定页
const handleJumpToPage = () => {
  if (jumpPage.value >= 1 && jumpPage.value <= length.value) {
    modelValue.value = jumpPage.value
    onChange(jumpPage.value)
  } else {
    // 如果输入无效，重置为当前页
    jumpPage.value = length.value
  }
}
// 分页变化
const handleSizeChange = () => {
  modelValue.value = 1
  emit('change', 1)
}

// 每页条数选项
const pageSizeItems = [
  { title: '10 条/页', value: 10 },
  { title: '20 条/页', value: 20 },
  { title: '50 条/页', value: 50 },
  { title: '100 条/页', value: 100 }
]

/** 分页变化事件 */
const emit = defineEmits(['change'])
const length = computed(() => {
  const pages = Math.ceil(props.total / props.pageSize)
  return pages === 0 ? 1 : pages
})

function onChange(page) {
  emit('change', page)
}

</script>
<style scoped lang="scss">
.table-pagination {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  margin: 10px 0 0;
  padding: 0 16px;
  gap: 16px;

  .pagination-info {
    font-size: 14px;
    color: rgba(46, 46, 46, 0.6);
    margin-right: auto;
  }

  .pagination-controls {
    display: flex;
    align-items: center;
  }

  .jump-to-page {
    display: flex;
    align-items: center;
    gap: 8px;
    font-size: 14px;
    margin-left: 16px;

    .jump-input {
      width: 80px;
    }
  }
}
</style>
